module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/component/pricing-booking/pricing/pricing.component.css
// module id = ./src/app/component/pricing-booking/pricing/pricing.component.css
// module chunks = main